import React, { useState } from "react";
import { Table, Form, Dropdown } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";

const priorityLabels = {
  high: { text: "Alta" },
  medium: { text: "Média" },
  low: { text: "Baixa" },
};

const formatDateTime = (dateStr) => {
  const date = new Date(dateStr);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).toString().padStart(2, "0");
  const mi = String(date.getMinutes()).toString().padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
};

const containerStyle = {
  backgroundColor: "#121843",
  borderRadius: "12px",
  padding: "20px",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
  maxWidth: "100%",
};

const scrollableTableStyle = {
  maxHeight: "43vh",
  overflowY: "auto",
  borderRadius: "8px",
  border: "1px solid #dee2e6",
};

const headerStyle = {
  marginBottom: "1rem",
  fontWeight: "bold",
  color: "white",
  textAlign: "center",
};

const thStyle = {
  backgroundColor: "#17296B",
  color: "white",
  fontWeight: "600",
  padding: "12px",
  textAlign: "center",
  verticalAlign: "middle",
};

const tdStyle = {
  padding: "12px",
  verticalAlign: "middle",
  textAlign: "center",
  borderBottom: "1px solid #e9ecef",
  color: "#212529",
  backgroundColor: "#f8f9fa",
};

const ImportantEvents = ({ events, selectedEvent }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("Todos");
  const filteredEvents = events.filter((event) =>
    event.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectFilter = (eventKey) => {
    setFilter(eventKey);
  };

  return (
    <div style={containerStyle}>
      <h5 style={headerStyle}>Próximos Eventos</h5>

      <hr style={{ borderTop: "2px solid white", margin: "10px 0" }} />

      <div className="d-flex align-items-center mb-4 gap-2">
        <Form.Control
          type="text"
          placeholder="Pesquisar..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Dropdown onSelect={handleSelectFilter}>
          <Dropdown.Toggle variant="outline-light" id="dropdown-filtro">
            <FaFilter /> {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="Todos">Todos</Dropdown.Item>
            <Dropdown.Item eventKey="Alta">Alta Prioridade</Dropdown.Item>
            <Dropdown.Item eventKey="Média">Média Prioridade</Dropdown.Item>
            <Dropdown.Item eventKey="Baixa">Baixa Prioridade</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div style={scrollableTableStyle}>
        <Table bordered hover className="mb-0">
          <thead>
            <tr>
              <th style={thStyle}>Status</th>
              <th style={thStyle}>Nome</th>
              <th style={thStyle}>Data</th>
              <th style={thStyle}>Tipo</th>
              <th style={thStyle}>Designados</th>
            </tr>
          </thead>
          <tbody>
            {filteredEvents.map((event, i) => {
              const priorityKey =
                Object.entries(priorityLabels).find(
                  ([, val]) => val.text === event.extendedProps?.priority
                )?.[0] ||
                event.extendedProps?.priority ||
                "low";

              const priorityText =
                priorityLabels[priorityKey]?.text || "Não Definido";
              const type = event.extendedProps?.type || "Não definido";
              const designados =
                event.extendedProps?.designados?.length > 0
                  ? event.extendedProps.designados.map((d) => d.name).join(", ")
                  : "—";
              const isSelected = selectedEvent?.id === event.id;

              return (
                <tr
                  key={i}
                  style={
                    isSelected
                      ? { backgroundColor: "#d1ecf1", }
                      : {}
                  }
                >
                  <td style={tdStyle}>{priorityText}</td>
                  <td style={tdStyle}>{event.title}</td>
                  <td style={tdStyle}>{formatDateTime(event.start)}</td>
                  <td style={tdStyle}>{type}</td>
                  <td style={tdStyle}>{designados}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ImportantEvents;
